import * as React from 'react';
import './editMode.scss';
import { useActions } from '../viewActions';
import { WarningDiamond } from 'rcd-cpp-ui/ui/icon/WarningDiamond';
import { Primary, Secondary } from 'rcd-cpp-ui/ui/button';

interface EditModeProps {
  description?: string;
  exitText?: string;
  handleSave?: () => Promise<void>;
  handleExit?: () => void;
}

export const EditMode = ({
  description,
  exitText,
  handleSave,
  handleExit
}: EditModeProps) => {
  const { setEditMode, resetInvalidCells } = useActions();
  const [isSaving, setIsSaving] = React.useState(false);

  const handleOnSave = async () => {
    if (handleSave) {
      setIsSaving(true);
      try {
        await handleSave();
      } finally {
        setIsSaving(false);
      }
    }
  };

  return (
    <div className="edit-mode">
      <div>
        <span>
          <WarningDiamond />
        </span>
        <span>Edit Mode</span>
        <span>|</span>
        <span>{description || "Custom metadata and planning items are editable"}</span>
      </div>
      <div className="edit-mode-buttons">
        {handleSave && (
          <Primary
            className="save-button"
            onClick={handleOnSave}
            disabled={isSaving}
          >
            Save
          </Primary>
        )}
         <Secondary
          onClick={ handleExit ? handleExit : () => {
            setEditMode(undefined);
            resetInvalidCells();
          }}>
          {exitText || `Exit edit mode`}
        </Secondary>
      </div>
    </div>
  );
};
